import controller from './mf-select-modal.controller';
import template from './mf-select-modal.html';

/**
 * @param {any} resolve
 * @returns {import('angular').ui.bootstrap.IModalSettings}
 */
export default ({ resolve }) => ({
	template,
	resolve,
	size:         'sm',
	controller,
	controllerAs: '$ctrl',
});
